import { render } from "./Select.vue?vue&type=template&id=022897e8&bindings={}"
import script from "./Select.vue?vue&type=script&lang=js"
export * from "./Select.vue?vue&type=script&lang=js"

import "./Select.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script